import React, { ReactElement } from 'react';
import { sizes, Space } from '../../../settings/spaces';
import styled from 'styled-components';
import { ResponsiveProp, resolveResponsiveProp } from '../utils/responsiveProps';
import { getNegativeCssValue } from '../utils/getNegativeCssValue/getNegativeCssValue';
import { joinAndFilter } from '../utils/joinAndFilter/joinAndFilter';

/* eslint-disable @typescript-eslint/no-empty-interface */
interface ReactNodeArray extends Array<ReactNodeNoStrings> {}
export type ReactNodeNoStrings = ReactElement | ReactNodeArray | boolean | null | undefined;

const inverseSizes: Record<Space, string> = Object.keys(sizes).reduce(
    (map, size) => ({
        ...map,
        [size]: getNegativeCssValue(map[size as Space]),
    }),
    sizes
);

export interface InlineProps {
    space: ResponsiveProp<Space>;
}

const Inline = styled.div<InlineProps>`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;

    ${({ space }) => {
        const spaces = joinAndFilter(
            resolveResponsiveProp(space, 'margin-top', inverseSizes),
            resolveResponsiveProp(space, 'margin-left', inverseSizes)
        );
        return spaces;
    }}

    > * {
        ${({ space }) => {
            const spaces = joinAndFilter(
                resolveResponsiveProp(space, 'margin-top', sizes),
                resolveResponsiveProp(space, 'margin-left', sizes)
            );
            return spaces;
        }}
    }
`;

export default Inline;
